import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { FadeUp } from '../../../components/shared/Motion';
import { EditableText, EditableImage, HrefPill } from '../../components';
import { getIcon } from '../iconMap';

function InfrastructureGrid({ data, onChange }) {
  const update = (patch) => onChange && onChange({ ...data, ...patch });
  const items = data.items || [];
  const updateItem = (i, patch) => {
    const next = items.map((x, idx) => (idx === i ? { ...x, ...patch } : x));
    update({ items: next });
  };
  return (
    <section id="infrastructure" className="relative py-24 lg:py-32 bg-white overflow-hidden">
      <div className="container-page">
        <FadeUp className="text-center max-w-3xl mx-auto mb-14">
          <span className="eyebrow justify-center"><span className="h-px w-8 bg-olive" />
            <EditableText value={data.eyebrow} onChange={(t) => update({ eyebrow: t })} as="span" />
          </span>
          <h2 className="section-title mt-4">
            <EditableText value={data.heading_prefix} onChange={(t) => update({ heading_prefix: t })} as="span" />
            <span className="text-gradient"><EditableText value={data.heading_highlight} onChange={(t) => update({ heading_highlight: t })} as="span" /></span>
            <EditableText value={data.heading_suffix} onChange={(t) => update({ heading_suffix: t })} as="span" />
          </h2>
        </FadeUp>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((item, i) => {
            const II = getIcon(item.icon);
            return (
              <FadeUp key={i} delay={i * 0.08}>
                <div className="group">
                  <div className="relative overflow-hidden rounded-2xl shadow-soft">
                    <EditableImage
                      src={item.image?.src}
                      alt={item.image?.alt || item.label}
                      onChange={(src, alt) => updateItem(i, { image: { src, alt } })}
                      className="h-64 w-full object-cover transition-transform duration-700 group-hover:scale-[1.06]"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-olive-footer/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                    <div className="absolute top-4 left-4 inline-flex h-10 w-10 items-center justify-center rounded-xl glass text-accent">
                      <II size={18} />
                    </div>
                  </div>
                  <EditableText value={item.label} onChange={(t) => updateItem(i, { label: t })} as="h3" className="mt-4 text-center font-bold text-olive-deep" />
                </div>
              </FadeUp>
            );
          })}
        </div>

        {data.cta && (
          <FadeUp delay={0.4}>
            <div className="mt-12 flex flex-col items-center">
              <Link to={data.cta.href || '#'} className="group inline-flex items-center gap-2 px-7 py-3 rounded-full bg-olive text-white font-semibold text-sm hover:bg-olive-deep hover:-translate-y-0.5 hover:shadow-glow-olive transition-all duration-300">
                <EditableText value={data.cta.label} onChange={(t) => update({ cta: { ...(data.cta || {}), label: t } })} as="span" />
                <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
              </Link>
              <HrefPill value={data.cta.href} onChange={(h) => update({ cta: { ...(data.cta || {}), href: h } })} />
            </div>
          </FadeUp>
        )}
      </div>
    </section>
  );
}

export default InfrastructureGrid;
